"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBusDestination = exports.MicrosoftEventHub = exports.AzNamespace = void 0;
/**
 * Azure SDK namespace.
 * @internal
 */
exports.AzNamespace = "az.namespace";
/**
 * Azure SDK Eventhub.
 * @internal
 */
exports.MicrosoftEventHub = "Microsoft.EventHub";
/**
 * Azure SDK message bus destination.
 * @internal
 */
exports.MessageBusDestination = "message_bus.destination";
//# sourceMappingURL=azAttributes.js.map